import { Component, OnInit } from '@angular/core';
import { EmployeeService } from '../../service/employee/employee.service';
import { HasPermissionService } from '../../service/has-permission/has-permission.service';
import { Employee } from '../../class/employee';
import { Message, ConfirmationService, LazyLoadEvent, CalendarModule, ToggleButtonModule } from 'primeng/primeng';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute } from '@angular/router';
import { config } from '../../../../../environments/config';
import { FormGroup, AbstractControl, FormBuilder, Validators, FormControl } from '@angular/forms';
import { formatDate } from '../../../../theme/functions/formatDate.function';
import { calendarES } from '../../../../theme/functions/calendarES';

@Component({
  selector: 'app-employees',
  templateUrl: './employees.component.html',
  styleUrls: ['./employees.component.scss']
})
export class EmployeesComponent implements OnInit {

    public promiseForm: Promise<any>;
    public msgs: Message[] = [];
    public employee: Employee[];
    public selectEmployee: Employee;
    public employeeID: Number = 0;
    public modNew = false;
    public modView = false;
    public openEmployee = false;
    public totalRecords: number;
    public page: number;
    public per_page: number;
    public sort: string;
    public query: string;
    public employeePosition: string;
    public filters: {key: string, value: string}[];

    public pagePath: string;
    public subPagePath: string;

    public modExportDialog: boolean;

    public apiUrl = config.API_ROOT;

    public es: any;

    public first = 0;

    public form3: FormGroup;
    public department_id_filter: AbstractControl;
    public venue_id_filter: AbstractControl;

    public form4: FormGroup;
    public f4_date_start: AbstractControl;
    public f4_date_end: AbstractControl;
    // public f4_export_type_filter: AbstractControl;

    constructor(
        public employeeService: EmployeeService,
        public confirmationService: ConfirmationService,
        public hasPermissionService: HasPermissionService,
        public translate: TranslateService,
        private route: ActivatedRoute,
        public fb: FormBuilder) {
            this.modExportDialog = false;

            this.es = calendarES();

            this.form3 = fb.group({
                'department_id_filter': [''],
                'venue_id_filter': [''],
            });
            this.department_id_filter = this.form3.controls['department_id_filter'];
            this.venue_id_filter = this.form3.controls['venue_id_filter'];

            this.form4 = fb.group({
                'f4_date_start': ['', [Validators.required]],
                'f4_date_end': ['', [Validators.required]],
            });
            this.f4_date_start = this.form4.controls['f4_date_start'];
            this.f4_date_end = this.form4.controls['f4_date_end'];
        }

    ngOnInit() {
        this.pagePath = this.route.snapshot.url[0].path;
        this.subPagePath = this.route.snapshot.url[1].path;
        switch (this.pagePath) {
            case 'management-claro':
                switch (this.subPagePath) {
                    case 'auxiliar':
                        this.employeePosition = '2';
                        this.filters = [];
                        this.filters.push({key: 'employee_position_id', value: this.employeePosition});
                    break;
                    case 'manager':
                        this.employeePosition = '3';
                        this.filters = [];
                        this.filters.push({key: 'employee_position_id', value: this.employeePosition});
                    break;
                }
            break;
            case 'selection':
                switch (this.route.snapshot.url[1].path) {
                    case 'selection-analyst':
                        this.employeePosition = '5';
                        this.filters = [];
                        this.filters.push({key: 'employee_position_id', value: this.employeePosition});
                    break;
                    case 'documental-analyst':
                        this.employeePosition = '8';
                        this.filters = [];
                        this.filters.push({key: 'employee_position_id', value: this.employeePosition});
                    break;
                    case 'hire-analyst':
                        this.employeePosition = '10';
                        this.filters = [];
                        this.filters.push({key: 'employee_position_id', value: this.employeePosition});
                    break;
                }
            break;
        }

        this.query = undefined;

        this.page = 1;
        this.per_page = 10;
        //this.getEmployee();
    }

    public loadEmployeeLazy(event: LazyLoadEvent) {
        this.page = (event.first / this.per_page) + 1;
        if (event.sortOrder === -1) {
            this.sort =  '-' + event.sortField;
        } else {
            this.sort =  event.sortField;
        }
        if (event.globalFilter) {
            this.query = event.globalFilter;
        } else {
            this.query = undefined;
        }

        this.sort = '-id';
        this.getEmployee(event.globalFilter);
    }

    public getEmployee(query?: string) {
      var _with = 'department.venue.company,venue.company,stations,employee_position,user,companies';
        this.employeeService.getEmployee(this.page, this.per_page, this.sort, query, this.filters, _with).toPromise().then(
            response => {
                this.employee = response.json().data;
                if (response.json().meta.total > response.json().meta.total_filtered) {
                    this.totalRecords = response.json().meta.total_filtered;
                } else {
                    this.totalRecords = response.json().meta.total;
                }
            },
            error => {
                this.msgs = [];
                this.msgs.push( { severity: 'error', summary: 'error' } );
            }
        );
    }

    public showExportDialog() {
        this.modExportDialog = true;
    }

    public cancelExport() {
        this.modExportDialog = false;
    }

    public exportReport(values) {
        this.exportReportExcel(values);
    }

    public exportReportExcel(values) {
        const f4_date_start = formatDate(values.f4_date_start);
        const f4_date_end = formatDate(values.f4_date_end);

        let url = this.apiUrl + '/events/excel-employee-events-done?' +
        'token=' + localStorage.getItem('token') +
        '&_page=1&_limit=100000&_sort=done_by_id&';

        if (f4_date_start) {
            url = url + 'done_at-min=' + f4_date_start + '&';
        }

        if (f4_date_end) {
            url = url + 'done_at-max=' + f4_date_end + '&';
        }

        // if (values.f4_export_type_filter) {
        //     url = url + 'type=' + values.f4_export_type_filter.value + '&';
        // }

        window.open(url, '_blank');
    }

    public newEmployee() {
        this.modNew = !this.modNew;
        this.selectEmployee = null;
    }

    public savedEmployee(res) {
        this.msgs = [];
        this.msgs.push(res);
        this.selectEmployee = null;
        this.modNew = false;
        // this.getEmployee();//Comentado porque existe componente y se quita y detecta load_lazy
    }

    public cancelEmployee (res) {
        this.selectEmployee = null;
        this.modNew = false;
        this.modView = false;
        // this.getEmployee();//Comentado porque existe componente y se quita y detecta load_lazy
    }

    public edit(employee: Employee) {
        this.modNew = true;
        this.selectEmployee = employee;
        this.getEmployee();
    }

    public view(employee: Employee) {
        this.openEmployee = true;
        this.selectEmployee = employee;
        this.employeeID = employee.id;
        this.modView = true;
    }

    public deleteDialog(employee: Employee) {
        let message;
        this.translate.get('Do you want to delete?').subscribe((res: string) => {
            message = res;
        });

        let header;
        this.translate.get('Delete Confirmation').subscribe((res: string) => {
            header = res;
        });

        this.confirmationService.confirm({
            message: message,
            header: header,
            icon: 'fa fa-trash',
            accept: () => {
                this.delete(employee);
            }
        });
    }

    public delete(employee: Employee) {
        this.employeeService.deleteEmployee(employee.id).toPromise().then(
            response => {
                this.msgs = [];
                this.msgs.push( { severity: 'success', summary: 'deleted' } );
                this.getEmployee();
            },
            error => {
                this.msgs = [];
                this.msgs.push( { severity: 'error', summary: 'error' } );
            }
        );
    }

    public activeEmployee(employee: Employee) {
        this.putEmployee(employee);
    }

    public putEmployee(values: Employee) {
        const param = {
            'activated': values.activated
        };
        if (values) {
            const promise = this.employeeService.updateEmployee(values.id, param);
            this.promiseForm = promise.toPromise().then(
                response => {
                    this.translate.get('saved').subscribe((res: string) => {
                        this.msgs = [];
                        this.msgs.push( { severity: 'success', summary: res  } );
                    });
                },
                error => {
                    this.msgs.push( { severity: 'error', summary: 'Error' } );
                }
            );
        }
    }
    public hasPermission(permission) {
        return this.hasPermissionService.hasPermission(permission);
    }

    public filter (values) {
        this.page = 1;
        this.first = 0;

        this.filters = [];
        if (values.department_id_filter) {
            this.filters.push({'key': 'department_id-lk', 'value': values.department_id_filter});
        }
        if (values.venue_id_filter) {
            this.filters.push({'key': 'venue_id-lk', 'value': values.venue_id_filter})
        }
        this.getEmployee();
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/employees/employees.component.ts